import { SupplierPrice } from "@/types/purchase";

export const getSuppLadderPrice = (price: SupplierPrice | null | undefined, val: number | string) => {
  let count = Number(val) || 0
  if (count === 0) return '';
  if (!!!price) return ''
  if (!!!price?.ladders?.length) return price?.price || ''
  else {
    let ladderPrice = price.ladders.sort((a, b) => b.count - a.count).find(it => Number(it.count) <= count)?.price || ''
    return ladderPrice;
  }
};
export const getSuppLadderPriceData = (price: SupplierPrice | null | undefined, val: number | string) => {
  let count = Number(val) || 0
  if (count === 0) return null;
  if (!!!price?.ladders?.length) return null;
  else {
    let ladderPrice = price.ladders.sort((a, b) => b.count - a.count).find(it => Number(it.count) <= count) || null
    return ladderPrice;
  }
};